import "./index.scss";

import { InputField, LabelField, MyCheckbox } from "components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import DeleteSvgComponent from "assets/icons/svg/DeleteSvg/Delete";
import AlertDialog from "components/Dialog";
import MyButton from "components/MyButton";
import { getCurrency } from "helper/numberFormat";
import { postalCodeFormat, postalCodeLabel } from "helper/postalCodeFormat";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useParams } from 'react-router-dom';
import thousands from "thousands";
import { checkIsStripe, checkIsTranzila } from "utils/checkIsStripe";
import AddInstallmentsPayment from "../../../../components/Installments/AddInstallmentsPayment";
import FinanceService from "../../../../Lib/API/Finance";
import { CheckFloatValue } from "../../../../utils/functions";
import StripeCard from "./StripeCard/StripeCard";
import TranzilaCard from "../../../../components/TranzilaCard/TranzilaCard";

const postalLabel = postalCodeLabel()

export const CreditCard = ({
  formik,
  title,
  onPaymentValueChange,
  selected,
  setSelected,
  accountId,
  calculateTotalPaidAmount,
  calculateTotalAmount,
  allowPaymentInstallment,
  enablePaymentInstallments,
  paymentGateway,
  setEnableAddCard,
  source,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  paymentMethodId,
  activeProvider,
}) => {
  const enableInstallments = useMemo(() => allowPaymentInstallment && enablePaymentInstallments, [allowPaymentInstallment, enablePaymentInstallments]);


  const [addNewCard, setAddNewCard] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [cards, setCards] = useState([]);
  const [cardDetail, setCardDetail] = useState({});
  const [checkCard, setCheckCard] = useState(false);
  const [checkSplitting, setcheckSplitting] = useState(false);
  const [addCardLoading, setAddCardLoading] = useState(false);
  const [setDefaultLoading, setSetDefaultLoading] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState({
    open: false,
    id: null,
    message: "",
    connected: false,
  });
  const [canDeleteLoading, setCanDeleteLoading] = useState(null);

  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();
  const dateTimeMask = maskDate();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormate || "mm/dd/yyyy");

  const { id } = useParams();
  const isMemberDetails = source === "updatePayments" || source === "managePayments";
  
  const customStyles = {
    width: 73,
    marginInline: "auto",
  };
  const setCardDefault = async () => {
    if (selected?.id) {
      const token = await getAccessTokenSilently();
      const data = {
        accountId: accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id === "" ? id : formik?.values?.account_name?.id ?? "",
        cardId: selected?.id,
      };
      setSetDefaultLoading(true);
      await FinanceService.setDefaultCreditCard(data, token)
        .then((res) => {
          toastr.success("Success", "Default card is checked!");
        })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      })
      .finally(() => {
        const timeOut = setTimeout(() => {
          setSetDefaultLoading(false);
        }, 2000);
        return () => {
          clearTimeout(timeOut);
        };
      });
      getCreditCards();
    }
  };

  useEffect(() => {
    setCardDefault();
  }, [checkCard]);

  useEffect(() => {
    if (selected?.id) {
      formik.setFieldValue("SelectedProviderId", selected.id)
    }
  }, [selected])

  const isStripe = useMemo(() => checkIsStripe(paymentGateway), [paymentGateway]);
  const isTranzila = useMemo(() => checkIsTranzila(paymentGateway), [paymentGateway]);
  const [tranzilaCurrency, setTranzilaCurrency] = useState("ILS");
  const getCreditCards = useCallback(async () => {

    if (formik?.values?.account_name?.id || id || accountId) {
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getCreditCardsByAccountId(
        token,
        accountId ? accountId : formik?.values?.account_name?.id === "" ? id : formik?.values?.account_name?.id ?? id,
        10,
        source === "updatePayments" ? activeProvider : undefined
      );
      setCards(res.card.data);

      const already = res.card.data?.find((item) => item?.is_default === true)

      // if (formik?.values?.paymentMethods) {

      //   const already = formik?.values?.paymentMethods?.find(
      //     (item) => item.name === "credit card"
      //   );
      //   if (already) {
      //     setSelected(already);
      //     formik.setFieldValue("cardDetail", already);
      //   }
      // }
      // else {
      if (already) {
        formik.setFieldValue("cardDetail", [already]);
        setSelected(already)
      } else if (res.card.data?.length === 1) {
        formik.setFieldValue("cardDetail", [res.card.data[0]]);
        setSelected(res.card.data[0])
      } else {
        formik.setFieldValue("cardDetail", []);
        setSelected({})
      }

      // }
    }

    if (formik?.values?.allData?.[0]?.Account?.id || id) {
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getCreditCardsByAccountId(
        token,
        accountId ? accountId : formik?.values?.allData?.[0]?.Account?.id ?? id,
        10,
        source === "updatePayments" ? activeProvider : undefined
      );
      setCards(res.card.data);

      const already = res.card.data?.find((item) => item?.is_default === true)

      if (already) {
        formik.setFieldValue("cardDetail", [already]);
        setSelected(already)
      } else if (res.card.data?.length === 1) {
        formik.setFieldValue("cardDetail", [res.card.data[0]]);
        setSelected(res.card.data[0])
      } else {
        formik.setFieldValue("cardDetail", []);
        setSelected({})
      }
    }

  }, [getAccessTokenSilently, formik?.values?.account_name?.id, formik.values?.allData]);

  useEffect(() => {
    if(!activeProvider || !cards?.length) return;
    const findSelectedCard = cards?.find(
      (item) => item.id === activeProvider
    );
    if (findSelectedCard) {
      setSelectedPaymentMethod({
        ...findSelectedCard,
        paymentMethodId,
      });
    }
  }, [activeProvider, cards]);
  // useEffect(() => {
  //   if (formik?.values?.paymentMethods) {
  //     const already = formik?.values?.paymentMethods?.find(
  //       (item) => item.name === "credit card"
  //     );
  //     if (already?.id === undefined) {
  //       setSelected(null);
  //       formik.setFieldValue("cardDetail", []);
  //     }
  //     else {
  //       setSelected(already);
  //       formik.setFieldValue("cardDetail", [already]);
  //     }
  //   }
  // }, [formik?.values?.paymentMethods])

  useEffect(() => {
    if (formik?.values?.cardDetail?.length > 0) {
      setSelected(formik?.values?.cardDetail?.[0])
    }

  }, [formik?.values?.cardDetail])

  useEffect(() => {
    if (formik.values?.cardDetail?.length === 0) {
      setSelected({})
      // formik.setFieldValue('cardDetail', [])
    }
  }, [formik.values.cardDetail])

  const onCardDetailChange = (event, name) => {
    setCardDetail({
      ...cardDetail,
      [name]: event.target?.value.slice(0, 16),
    });
    formik.setFieldValue(
      `cardDetails.${name}`,
      event.target?.value.slice(0, 16)
    );
  };

  useEffect(() => {
    // if (formik?.values?.values?.[0]?.charge?.payment?.status !== "declined" && formik?.values?.values?.[0]?.isRecurring) {
    getCreditCards();
    // }
  }, [getCreditCards]);

  useEffect(() => {
    if (selected) {
      onPaymentValueChange(title, {
        target: {
          value: title,
          name: "paymentMethod",
        },
      });
      onPaymentValueChange(title, {
        target: {
          value: selected.id,
          name: "cardId",
        },
      });

      formik.setFieldValue("last4", selected.last4);
    }
    //eslint-disable-next-line
  }, [formik?.values?.creditCardAmount]);
  const onSaveCard = async (tokenId = "", tranzilaResult = null) => {
    const cardsDetails = {
      object: "card",
      ...cardDetail,
    };
    const token = await getAccessTokenSilently();

    if ((!cardDetail?.cvc || cardDetail?.cvc === "") && !tokenId) {
      return toastr.error("Error", "Please add CVC.")
    }
    if (cardDetail?.cvc?.length < 3 && !tokenId) {
      return toastr.error("Error", "Please enter valid CVC.")
    }

    if(!tokenId && !cardDetail?.zip?.length) {
      return toastr.error("Error", `Please enter ${postalCodeLabel()}.`)
    }
    const validZipCode =  postalCodeFormat(cardDetail?.zip);
    if (!validZipCode && !tokenId) {
      toastr.info("Validation", `Invalid ${postalCodeLabel()}`);
    }


    const bodyData = {};
    if(isStripe && tokenId){
      bodyData.token = tokenId;
    } else if (isTranzila && tokenId && tranzilaResult) {
      bodyData.token = tokenId;
      bodyData.cardsDetails = {
        object: 'card',
        number: tokenId,
        exp_month: tranzilaResult.expmonth ? String(Number(tranzilaResult.expmonth)) : undefined,
        exp_year: tranzilaResult.expyear ? `20${tranzilaResult.expyear}` : undefined,
      };
      bodyData.tranzilaData = tranzilaResult;
      bodyData.currency = tranzilaCurrency;
    } else {
      bodyData.cardsDetails = cardsDetails;
    }

    setAddCardLoading(true)
    FinanceService.addCreditCard(
      token,
      accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id === "" ? id : formik?.values?.account_name?.id ?? "",
      bodyData,
    )
      .then((res) => {
        getCreditCards();
        formik.setFieldValue(`cardDetails.exp_month`, "");
        formik.setFieldValue("cardDetails.exp_year", "");
        formik.setFieldValue("cardDetails.cvc", "");
        formik.setFieldValue("cardDetails.number", "");
        formik.setFieldValue("cardDetails.zip", "");
      

        setCardDetail({});
        setAddNewCard(false);
        if ((formik?.values?.values?.[0]?.charge?.payment?.status !== "declined" && formik?.values?.values?.[0]?.isRecurring) || tokenId) {
          setEnableAddCard && setEnableAddCard(false);
        }
        if (formik?.values?.values?.[0]?.charge?.payment?.status === "declined" && formik?.values?.values?.[0]?.isRecurring) {
          setSelected(res.card)
        }
        toastr.success("Success", "Card Added Successfully");
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Please enter valid card details");
      }).finally(() => {
        setAddCardLoading(false)
      });
  };

  const checkCanDelete = async (id) => {
    if(canDeleteLoading) return;
    setCanDeleteLoading(id);
    const token = await getAccessTokenSilently();
    FinanceService.checkConnectedPaymentMethod({
      token,
      id,
      accountId: accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id === "" ? id : formik?.values?.account_name?.id ?? "",
    }).then((response) => {
      if(response?.connected) {
        openConfirmDialog(id, "This payment method is linked to an installment or recurring payment. Are you sure you want to delete it?", true);
      } else {
        openConfirmDialog(id, "Do you want to delete this credit card?", false);
      }
    }).catch((err) => {
      toastr.error("Error", err?.data?.message || "Something went wrong");
    }).finally(() => {
      setCanDeleteLoading(null);
    });
  }


  const onDelete = async (idx) => {

    const token = await getAccessTokenSilently();
    FinanceService.deleteCreditCard(
      token,
      idx,
      accountId ? accountId : formik?.values?.allData?.length > 0 ? formik?.values?.allData?.[0]?.Account?.id : formik?.values?.account_name?.id === "" ? id : formik?.values?.account_name?.id ?? "",
    ).then(() => {
      if(selectedPaymentMethod?.id === idx) {
        setSelectedPaymentMethod(null);
      }
      getCreditCards();
      setSelected(null);
      if(confirmDeleteModal.connected) {
        window.dispatchEvent(new CustomEvent("save-transaction"));
      }
    }).catch((err) => {
      toastr.error("Error", err?.data?.message);
    }).finally(() => {
      closeConfirmDialog();
    });
  };

  // useEffect(() => {
  //   if (formik.values.SelectedProviderId) {
  //     const already = cards?.find(
  //       (item) => item.id === formik.values.SelectedProviderId
  //     );
  //     console.log(already, "alreadyalready")
  //     formik.setFieldValue("cardDetail", [already]);
  //   }

  // }, [formik.values.creditCardAmount])

  const onSelect = (data, e) => {
    if(setDefaultLoading) return;
    if (data?.id === selected?.id) {
      formik.setFieldValue("cvc", "");
      formik.setFieldValue("cardDetail", []);
      setSelected({});
      source === "updatePayments" && setSelectedPaymentMethod(null);

    }
    else {
      formik.setFieldValue("cvc", "");
      formik.setFieldValue("cardDetail", data);
      setSelected({ ...data });
      source === "updatePayments" && setSelectedPaymentMethod({
        ...data,
        paymentMethodId,
      });
    }
  };
  useEffect(() => {
    const already = formik?.values?.payments?.find(
      (item) => item.paymentMethod === title
    );
    if (already) {
      const current = cards?.find((item) => item.id === already.cardId);
      // setSelected(current);
    }
  }, [cards]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (formik?.values?.creditCardAmount) {
  //       if (formik?.values?.cardDetail) {
  //       } else {
  //         return toastr.info("Validation", "Please Add/Select a Credit Card!");
  //       }
  //     }
  //   }, 2000);
  // }, [formik?.values?.creditCardAmount]);
  useEffect(() => {
    setTimeout(() => {
      if (formik?.values?.creditCardAmount) {
        if (formik?.values?.cardDetail) {
          if (formik?.values?.cvc) {
          } else {
            // toastr.info("Validation", "Please enter CVC");
          }
        } else {
        }
      }
    }, 1000);
  }, [formik?.values?.creditCardAmount]);

  const handleOnload = () => {
    const myInput = document.getElementById("myInput");
    myInput.onpaste = (e) => e.preventDefault();
  };

  useEffect(() => {
    cards &&
      cards.map((item) => {
        if (item?.is_default) {
          setSelected(item);
          // setCheckCard(item?.is_default);
        }
      });
  }, [cards]);

  // useEffect(() => {
  //   if (formik?.values?.values?.[0]?.charge?.payment?.status === "declined" && formik?.values?.values?.[0]?.isRecurring) {
  //     setAddNewCard(true);
  //   }
  // }, [formik?.values?.values])

  const openConfirmDialog = (id, message, connected) => {
    setConfirmDeleteModal((prev) => ({
      ...prev,
      open: true,
      message,
      id: id,
      connected: connected,
    }));
  };

  const closeConfirmDialog = () => {
    setConfirmDeleteModal((prev) => ({
      ...prev,
      open: false,
      message: "",
      id: null,
      connected: false,
    }));
  };

  const calculateRemainingBalance = () => {
    return calculateTotalAmount() - calculateTotalPaidAmount();
   }

     const isOptionalObject = useMemo(() => {

      if (

        !Array.isArray(formik["values"]["allPaymentsMethods"]) ||

        formik["values"]["allPaymentsMethods"].length === 0

      )

        return;

  

      const currentComponent = formik["values"]["allPaymentsMethods"].find(

        (item) => {
            console.log("testing", formik["values"]["allPaymentsMethods"],formik?.values)
          return item.type === "credit card";

        }

      );

  

      if (!currentComponent||!currentComponent?._id) return;

  console.log(currentComponent,currentComponent?._id,'testing')

      return  {   id:currentComponent?._id,
        coverConvenienceFee: currentComponent?.coverConvenienceFee ?? false, 
        isOptional:currentComponent?.convenienceFeeInfo?.optional ?? false,

          message:currentComponent?.convenienceFeeInfo?.message,

          type: currentComponent?.type,

      }

    }, [formik["values"]]);  

 useEffect(() => {
  if (!isOptionalObject?.isOptional) return;
  if (!key) return;

  if (formik.values[key] === undefined) {
    formik.setFieldValue(key, true);
  }
}, [key, isOptionalObject]);

      const key = isOptionalObject?.id;

  return (
    <>
      {formik?.values?.checkAch !== true &&
        <div>
          {
            (formik?.values?.values?.[0]?.charge?.payment?.status !== "declined" && formik?.values?.values?.[0]?.isRecurring) &&
            <>
              {formik?.values?.values?.[0]?.is_splitted && <div className="left-side px-0 mb-4">
                <div className="d-flex">
                  <MyCheckbox
                    name={"default"}
                    title=""
                    value={checkSplitting}
                    onClick={(e) => {
                      formik.setFieldValue(
                        `checkSplitting`,
                        !checkSplitting
                      );
                      setcheckSplitting(!checkSplitting);
                    }}
                  />
                  <LabelField title="Use for Split Payment" />
                </div>
              </div>}
            </>
          }
          <div className="form-row col-sm-12 px-0 mt-4" style={{ alignItems: "flex-start" }}>
            <div className="d-flex col-sm-7 " style={{ alignSelf: "flex-start" }}>
              <div className="cards-radio font-16">
                {cards?.map((item) => {
                  const isSelected = source === "updatePayments" ? selectedPaymentMethod?.id === item.id : selected?.id === item.id;
                  return (
                  <div
                    key={item.id}
                    className={`d-flex align-items-start ${isSelected ? "selected-card" : ""} ${setDefaultLoading ? "disabled-card" : ""}`}
                    style={{ marginBottom: "10px" }}
                  >
                    <MyCheckbox
                      name={`card-select-${item.id}`}
                      checked={isSelected}
                      title=""
                      handlechange={() => onSelect(item)}
                    />
                    <p style={{ margin: 0, cursor: "pointer" }} onClick={() => onSelect(item)}>
                      {`${item.country ? item.country : ""} ${item.brand ? item.brand : ""
                        } (${item.last4 ? item.last4 : ""}${item.currency === 'USD' ? ' $' : item.currency === 'ILS' ? ' ₪' : ''}), Exp: ${item.exp_month}/${item.exp_year
                        }`}
                      {canDeleteLoading === item.id ? (
                        <span className="spinner spinner-black"></span>
                      ) : (
                      <DeleteSvgComponent
                        color={"gray"}
                        onClick={(e) => {
                          e.stopPropagation();
                          checkCanDelete(item.id);
                        }}
                      />
                      )}
                      {((item.hasOwnProperty("address_zip") && !item?.address_zip) || ((item.hasOwnProperty("zip") && item?.zip === "zip is missing"))) && (
                        <span className="text-danger missing-zip">{postalLabel} is missing</span>
                      )}
                    </p>
                  </div>
                  );
                })}
              </div>
            </div>
            <div className="right-side px-0" style={{ minWidth: "216px" }}>
              {!!cards?.length && (
                <div className="d-flex mb-2">
                  <MyCheckbox
                    name={"default"}
                    checked={source === "updatePayments" ? selectedPaymentMethod?.is_default : selected?.is_default}
                    title=""
                    value={checkCard}
                    onClick={(e) => {
                      setCheckCard(!checkCard);
                    }}
                  />
                  <LabelField title="Set as default credit card" />
                </div>
              )}
              {!!cards?.length && enableInstallments && (
                <div className="d-flex mb-2"
                  style={(formik.values?.allowAchInstallment || formik.values?.cc_future_enabled || formik.values?.ach_future_enabled) ? { opacity: 0.7, pointerEvents: "none" } : {}}
                >
                  <MyCheckbox
                    name={"Installments-pay"}
                    checked={formik.values.allowCreditInstallment}
                    title=""
                    onClick={(e) => {
                      if(!formik?.values?.creditCardAmount) {
                        formik.setFieldValue("creditCardAmount", calculateRemainingBalance());
                      } else {
                        formik.setFieldValue("allowAchInstallment", false);
                        formik.setFieldValue("installmentAchDetails",{
                          cycle: "",
                          frequency: "",
                          startInstallment: new Date(),
                        });
                      }
                      formik.setFieldValue("allowCreditInstallment", e.target.checked);
                    }}
                    disabled={formik.values?.allowAchInstallment || formik.values?.cc_future_enabled || formik.values?.ach_future_enabled}
                  />
                  <LabelField title="Pay in Installments" />
                </div>
              )}
              {!!cards?.length && isOptionalObject?.coverConvenienceFee && isOptionalObject?.isOptional && (
                <div className="d-flex mb-2">
                  <MyCheckbox
                    name={key}
                    checked={formik.values?.[key]}
                    title=""
                    onClick={(e) => {
                      formik.setFieldValue(key, e.target.checked);
                    }}
                  />
                  <LabelField title="Convenience Fee" />
                </div>
              )}
              {!isMemberDetails && (
              <div className="d-flex mb-2"
                style={(formik.values?.allowCreditInstallment || formik.values?.allowAchInstallment || formik.values?.ach_future_enabled || formik?.values?.values?.[0]?.isRecurring) ? { opacity: 0.7, pointerEvents: "none" } : {}}
              >
                <MyCheckbox
                  name="cc_future_enabled"
                  title=""
                  checked={formik.values?.cc_future_enabled}
                  onClick={(e) => {
                    formik.setFieldValue("cc_future_enabled", e.target.checked);
                    if (!e.target.checked) formik.setFieldValue("cc_future_date", null);
                  }}
                  disabled={formik.values?.allowCreditInstallment || formik.values?.allowAchInstallment || formik.values?.ach_future_enabled || formik?.values?.values?.[0]?.isRecurring}
                />
                <LabelField title="Future Payment" />
              </div>
              )}
            </div>
          </div>
          <div
            className="my-5 d-flex col-sm-7"
            onClick={() => {
              setEnableAddCard && setEnableAddCard((prev) => !prev);
              setAddNewCard(!addNewCard)
            }}
          >
            <div className="add-new-payment-info">
              <span className="add-icon">
                <AddIcon />
              </span>
              <span className="add">Add New Card</span>
            </div>
          </div>
          {addNewCard && (
            <>
              {isTranzila && (
                <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 12, marginTop: 12 }}>
                  <span style={{ fontSize: 13, fontWeight: 500 }}>Currency:</span>
                  {["ILS", "USD"].map(cur => (
                    <button
                      key={cur}
                      type="button"
                      onClick={() => setTranzilaCurrency(cur)}
                      style={{
                        padding: "6px 16px",
                        borderRadius: 6,
                        border: tranzilaCurrency === cur ? "2px solid #2555EF" : "1px solid #e2e8f0",
                        background: tranzilaCurrency === cur ? "#EEF2FF" : "#fff",
                        color: tranzilaCurrency === cur ? "#2555EF" : "#333",
                        fontWeight: tranzilaCurrency === cur ? 600 : 400,
                        fontSize: 13,
                        cursor: "pointer",
                      }}
                    >
                      {cur === "ILS" ? "₪ ILS" : "$ USD"}
                    </button>
                  ))}
                </div>
              )}
              {isTranzila ? (
                <TranzilaCard
                  onSaveCard={onSaveCard}
                  loading={addCardLoading}
                  setLoading={setAddCardLoading}
                  saveCard={true}
                  currency={tranzilaCurrency}
                  terminalName={paymentGateway?.keys?.terminal_name}
                />
              ) : isStripe ? (
                  <StripeCard onSaveCard={onSaveCard}
                    loading={addCardLoading}
                    setLoading={setAddCardLoading}
                    publicKey={paymentGateway?.keys?.publicKey}
                  />
                ) : (
                <div className="row mt-3">
                  <div className="col-sm-4 pr-0">
                    <InputField
                      mandatory
                      {...{
                        formik,
                        title: "Card Number",
                        name: "cardDetails.number",
                        value: formik.values.cardDetails?.number?.slice(0, 16),
                        type: "number",
                        maxLength: 15,
                        minlength: 16,
                        pattern: "[0-9]{10}",
                        placeholderIcon: (
                          <CreditCardOutlinedIcon
                            className="card-icon align-self-center"
                            fontSize="large"
                          />
                        ),
                      }}
                      id="myInput"
                      onKeyPress={(event) => {
                        handleOnload();
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onpaste={handleOnload}
                      handleChange={(event) => {
                        onCardDetailChange(event, "number");
                      }}
                    />
                  </div>
                  <div className="col-sm-2">
                    <InputField
                      mandatory
                      {...{
                        formik,
                        title: "Expiry Month",
                        name: `cardDetails.exp_month`,
                        placeholder: "MM",
                        minlength: "1",
                        maxLength: "2",
                        type: "string",
                        value: formik.values?.cardDetails?.exp_month ?? "",
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      handleChange={(event) => onCardDetailChange(event, "exp_month")}
                    />
                  </div>
                  <div className="col-sm-2">
                    <InputField
                      mandatory
                      {...{
                        formik,
                        title: "Expiry Year",
                        type: "string",
                        minlength: "4",
                        maxLength: "4",
                        name: `cardDetails.exp_year`,
                        placeholder: "YYYY",
                        value: formik.values?.cardDetails?.exp_year ?? "",
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      handleChange={(event) => onCardDetailChange(event, "exp_year")}
                    />
                  </div>
                  <div className="col-sm-2 px-0">
                    <InputField
                      mandatory
                      {...{
                        formik,
                        title: "CVC",
                        type: "string",
                        minlength: "3",
                        maxLength: "4",
                        name: `cardDetails.cvc`,
                        placeholder: "3-4 digits",
                        value: formik.values?.cardDetails?.cvc ?? "",
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      handleChange={(event) => onCardDetailChange(event, "cvc")}
                    />
                  </div>
                  <div className="col-sm-2">
                    <InputField
                      mandatory
                      {...{
                        formik,
                        title: postalLabel,
                        name: `cardDetails.zip`,
                        placeholder: postalLabel,
                        type: "string",
                        value: formik.values?.cardDetails?.zip ?? "",
                      }}
                      handleChange={(event) => onCardDetailChange(event, "zip")}
                    />
                  </div>
                  <div className="col-sm-4 mb-5 pb-5 pt-5">
                    <MyButton
                      content={"Save Card"}
                      style={{ width: 120 }}
                      onClick={() => {
                        onSaveCard();
                      }}
                    />
                  </div>
                </div>
              )}
            </>

          )}
            <AlertDialog
              open={confirmDeleteModal.open}
              handleClose={() => {
                closeConfirmDialog();
              }}
              onDecline={closeConfirmDialog}
              onAccept={() => {
                onDelete(confirmDeleteModal.id);
              }}
              title={"Are you sure?"}
              description={confirmDeleteModal.message}
              contentStyle={{
                fontSize: "18px",
              }}
          />
        </div >}
        {(formik.values.allowCreditInstallment && enableInstallments) && (
          <AddInstallmentsPayment
            formik={formik}
            formikKey="installmentCreditDetails"
            installmentFieldLabel="Installments"
            dateFieldLabel="First payment date"
            dateRequired={true}
          />
        )}
        {formik.values?.cc_future_enabled && (
          <div className="row my-5 add-installment-payment">
          <div className="col-12 col-md-6">
            <LabelField title="Payment Date" mandatory />
            <DatePicker
              showIcon
              popperPlacement="top"
              popperProps={{ strategy: "fixed" }}
              placeholderText={placeholderFormat}
              dateFormat={dateFormate}
              selected={formik.values?.cc_future_date ? new Date(formik.values.cc_future_date) : null}
              onChange={(date) => formik.setFieldValue("cc_future_date", date)}
              minDate={new Date()}
              customInput={
                <MaskedInput
                  pipe={autoCorrectedDatePipe}
                  mask={dateTimeMask}
                  keepCharPositions={true}
                  guide={true}
                />
              }
            />
          </div>
          </div>
        )}
    </>
  );
};
export const CreditCardHeader = ({ selected, formik, ...props }) => {
const currency = getCurrency();
  const { expanded, current } = props;
  const [disableInput, setDisableInput] = useState(true);

  const preventMinus = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };
  const handlefieldClick = (e) => {
    if (e.stopPropagation && expanded === true) {
      e.stopPropagation();
    }
    if (!selected?.id && e.stopPropagation && expanded === true) {
      e.stopPropagation();
    }
  };

  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(parseFloat(num?.toString().replace(/,/g, "")))
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  useEffect(() => {
    if (expanded === true && formik?.values?.checkAch === true) {
      toastr.error('You can select only one payment method')
    }

    if (expanded === true && formik?.values?.checkAchSplit === true) {
      toastr.error('You can select only one payment method')
    }

    if (expanded === false && formik.values?.creditCardAmount === "") {
      formik.setFieldValue("cardDetail", [])
    }

  }, [expanded])


  // useEffect(() => {
  //   if (formik?.values?.values?.[0]?.isRecurring && formik.values.actual_total) {
  //     props.onCreditCardAmountChange(formik.values.actual_total)
  //   }

  // }, [formik?.values?.values])

  return (
    <div
      className={
        expanded === false && !formik?.values?.creditCardAmount
          ? "accordion-payment-header"
          : expanded === false &&
            current?.includes("credit card") === false &&
            formik?.values?.creditCardAmount
            ? "accordion-header"
            : expanded === false
              ? "accordion-header"
              : expanded === false
                ? "accordion-payment-header accordion-header "
                : expanded === true
                  ? "accordion-header"
                  : "accordion-header-payment"
      }
    >
      <LabelField title="Credit Card" />

      <div
        className={
          expanded === false && formik?.values?.creditCardAmount
            ? "custom-expand dollor-icon col-sm-3 nonexpanded-amount"
            : "col-sm-3"
        }
      >
        {expanded === false && formik?.values?.creditCardAmount ? (
          <div className="cash-non-expanded">
            <span>{currency}</span>
            <span>
              {isNaN(formik?.values?.creditCardAmount) ? "0.00" : parseFloat(formik?.values?.creditCardAmount).toFixed(2)}
            </span>
          </div>
        ) : current?.includes("credit card") && expanded === true ? (
          <>
            {
              formik?.values?.values?.[0]?.isRecurring || formik?.values?.values?.[0]?.charge?.payment?.status === "declined" ? currency + thousands((+formik?.values?.actual_total).toFixed(2)) :
                <InputField
                  {...{
                    formik,
                    title: "none",
                    name: `amount`,
                    style: { background: "#ffff", border: "none" },
                    placeholderIcon: (
                      <span
                        className="align-self-center px-4"
                        style={{ color: "black" }}
                      >
                        {currency}
                      </span>
                    ),
                    value: formik?.values?.creditCardAmount,
                  }}
                  // disbaled={formik?.values?.values?.[0]?.isRecurring}
                  // disabled={
                  //   selected?.id && formik?.values?.cvc
                  //     ? setDisableInput === false
                  //     : true
                  // }
                  // onKeyDown={preventMinus}
                  handleChange={props.onCreditCardAmountChange}
                  paymentInput="paymentInput"
                  handleFocus={(e) => handlefieldClick(e)}
                // disabled
                />

            }</>

        ) : expanded === false &&
          current?.includes("credit card") === false &&
          formik?.values?.creditCardAmount ? (
          <div className="cash-non-expanded">
            <span>{currency}</span>
            <span>
              {isNaN(formik?.values?.creditCardAmount) ? "0.00" : parseFloat(formik?.values?.creditCardAmount).toFixed(2)}
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};